"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CameraPermissionWatcher = void 0;
var tslib_1 = require("tslib");
var react_1 = require("react");
var react_redux_1 = require("react-redux");
var sentrySdk_1 = require("../../sdks/sentry/sentrySdk");
var SentrySeverity_1 = require("../../sdks/sentry/SentrySeverity");
var description = 'CameraPermissionWatcher';
var CameraPermissionWatcher = function (_a) {
    var dispatch = (0, react_redux_1.useDispatch)();
    (0, react_1.useEffect)(function () {
        var cameraPermission = null;
        var run = function () { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
            var error_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        // Ensure we have access to the Permissions API
                        if (!navigator.permissions) {
                            // 'Permissions API is not supported in this browser.'
                            return [2 /*return*/];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, navigator.permissions.query({
                                name: 'camera',
                            })];
                    case 2:
                        // Query the camera permission status
                        cameraPermission = _a.sent();
                        dispatch({
                            type: 'SET_WINDOW_META',
                            description: description,
                            values: {
                                cameraPermission: cameraPermission.state,
                            },
                        });
                        // Listen for changes in the permission state
                        cameraPermission.onchange = function () {
                            dispatch({
                                type: 'SET_WINDOW_META',
                                description: description,
                                values: {
                                    cameraPermission: cameraPermission === null || cameraPermission === void 0 ? void 0 : cameraPermission.state,
                                },
                            });
                        };
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        (0, sentrySdk_1.sentrySdk)().captureMessage("".concat(description, " An error occurred while checking camera permissions"), SentrySeverity_1.SentrySeverity.Critical);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        run();
        return function () {
            if (cameraPermission) {
                cameraPermission.onchange = null;
            }
        };
    }, [dispatch]);
    return null;
};
exports.CameraPermissionWatcher = CameraPermissionWatcher;
